// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#2f5f63"};